import { defineNuxtPlugin } from '#app'

function getGtmID(site: string) {
  switch (site) {
    case 'pharmago':
      return 'GTM-NDMKMWKQ'
    case 'fphch':
      return 'GTM-TJ5V3CN6'
  }

  return 'GTM-MVBX9N7'
}

/**
 * Loads the global config and puts it in the globalConfig store.
 *
 * Only happens during SSR.
 */
export default defineNuxtPlugin({
  name: 'phs-analytics',
  dependsOn: ['phs:track-page-load', 'phs:track-switch-page'],
  setup(nuxtApp) {
    const { name: siteName } = useCurrentSite()

    useHead({
      script: [
        {
          key: 'gtm',
          innerHTML: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${getGtmID(siteName)}');
          `,
        },
      ],
    })

    if (import.meta.client) {
      return
    }

    // Where the dataLayer stuff is stored during SSR. We attach it to the
    // head after the page was rendered.
    const ssrDataLayer = useState<any[]>('ssrDataLayer', () => [])

    nuxtApp.hook('app:rendered', (ctx) => {
      ctx.ssrContext?.head.push({
        script: [
          {
            innerHTML: `window.dataLayer = ${JSON.stringify(
              ssrDataLayer.value,
            )}`,
            tagPriority: -100,
          },
        ],
      })
      ssrDataLayer.value = []
    })
  },
})
